import { Gender, UserRole } from "@joonapp/web-shared"
import { create } from "zustand"

import { AddChildStep } from "../../../types"

interface AddFamilyMemberModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void

  type: UserRole
  birthday: string
  name: string
  gender: Gender | null
  setType: (type: UserRole) => void
  setName: (name: string) => void
  setBirthday: (birthday: string) => void
  setGender: (gender: Gender | null) => void

  step: AddChildStep
  setStep: (step: AddChildStep) => void
}

const initialState = {
  isOpen: false,
  type: UserRole.CHILD,
  birthday: "",
  name: "",
  gender: Gender.FEMALE,
  step: AddChildStep.NAME,
}

export const useAddFamilyMemberModalStore = create<AddFamilyMemberModalStore>(
  (set) => ({
    ...initialState,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set(initialState),

    setType: (type) => set({ type }),
    setName: (name) => set({ name }),
    setBirthday: (birthday) => set({ birthday }),
    setStep: (step) => set({ step }),
    setGender: (gender) => set({ gender }),
  })
)
